import React from 'react';
import { MapPin } from 'lucide-react';
export function ServiceArea() {
  const cities = ['Phoenix', 'Gilbert', 'Mesa', 'Chandler', 'Tempe', 'Scottsdale', 'Queen Creek', 'San Tan Valley'];
  return <section id="service-area" className="py-20 relative overflow-hidden bg-navy text-white" data-id="element-101">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-102">
        <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full bg-gold blur-3xl" data-id="element-103" />
        <div className="absolute -left-20 -bottom-20 w-96 h-96 rounded-full bg-blue-500 blur-3xl" data-id="element-104" />
      </div>

      <div className="container px-4 md:px-6 mx-auto relative z-10" data-id="element-105">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-106">
          <div className="flex-1 text-center lg:text-left" data-id="element-107">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-108">
              Proudly Serving the{' '}
              <span className="text-gold" data-id="element-109">Phoenix Metro Area</span>
            </h2>
            <p className="text-lg text-gray-300 mb-8 max-w-xl mx-auto lg:mx-0" data-id="element-110">
              We bring our professional window cleaning services to homes and
              businesses across the East Valley and beyond.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 max-w-lg mx-auto lg:mx-0" data-id="element-111">
              {cities.map(city => <div key={city} className="flex items-center gap-2 text-gray-200" data-id="element-112">
                  <MapPin className="h-4 w-4 text-gold flex-shrink-0" data-id="element-113" />
                  <span className="font-medium" data-id="element-114">{city}</span>
                </div>)}
            </div>

            <div className="mt-8 text-sm text-gray-400 italic" data-id="element-115">
              *Serving surrounding communities as well. Call to confirm your
              location!
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-116">
            <div className="relative aspect-square md:aspect-video lg:aspect-square rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/mX1DbtkSFVBUzgb56t4vbR/james-day-jUyNP55873k-unsplash.jpg" alt="Beautiful Arizona home with sparkling clean windows in the Phoenix metro area" className="w-full h-full object-cover opacity-80 hover:opacity-100 transition-opacity duration-500" data-id="element-118" />
              <div className="absolute inset-0 flex items-center justify-center bg-navy/30 pointer-events-none" data-id="element-119">
                <span className="bg-navy/80 backdrop-blur-sm px-6 py-3 rounded-full text-white font-bold border border-white/20" data-id="element-120">
                  Serving the East Valley
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}